export const OktaClientId = '0oa15aymctiioGwei697'
export const ENV = 'pp135' as string
export const OVERSIGHT_ENV_NAME = 'oversight'
export const GCS_ENV_NAME = 'pp135'
export const SUBDOMAIN_SUFFIX = 'gcs'
